// extracted by mini-css-extract-plugin
export default {"content":"TkauthRedirect_content__VAC6A"};